import { RequestDtoSchema } from "@/types/request";
import { z } from "zod";

export const ProjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  creationDate: z.coerce.date(),
  lastUpdateDate: z.coerce.date(),
  favorite: z.boolean(),
  description: z.string(),
});

export type Project = z.infer<typeof ProjectSchema>;

export type RequestUpdateProject = {
  favorite: boolean;
  name: string;
  description: string;
};

export type RequestCreateProject = {
  name: string;
  description: string;
};

export const ProjectWithRequestsSchema = ProjectSchema.merge(
  z.object({
    requests: z.array(RequestDtoSchema),
  })
);

export type ProjectWithRequestsResponse = z.infer<
  typeof ProjectWithRequestsSchema
>;
